import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            width: '100%',
            border: `1px ${colors.color13} dashed`,
            minHeight: '10px',
            borderRadius: '8px',
            padding: 3,
            position: 'relative'
        },
        addSectionButton: {
            display: 'flex',
            alignItems: 'center',
            gap: 3
        },
        
        footer: {
            width: '100%',
            display: 'flex',
            gap: 1,
            justifyContent: 'end',
            alignItems: 'center',
            padding: '0px 24px',
            '& .MuiIconButton-root': {
                fontSize: '30px',
                width: '30px',
                height: '30px',
                '& .MuiSvgIcon-root': {
                    fontSize: '1em',
                    width: '1em',
                    height: '1em',
                }
            }
        },
        add: {
            fontSize: '30px',
            width: '30px',
            height: '30px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
                width: '1em',
                height: '1em',
            },
            '&.blue': {
                color: colors.color1,
            }
        },
    }
}

export { useStyles }
